import React, { Fragment } from 'react';
import useStyles from 'hooks/useStyles';
import { useTranslation } from 'react-i18next';

import { SuccessIcon } from 'components/Icon';
import styles from './ThanksInfo.scss';

const ThanksInfo = () => {
  useStyles(styles);
  const { t } = useTranslation(['rating']);

  return (
    <Fragment>
      <SuccessIcon />
      <h4 className={styles.title}>{t('common.submitMessage')}</h4>
    </Fragment>
  );
};

export default ThanksInfo;
